import React, { type ReactElement } from 'react';
import TableActions from 'atom-components/table-actions-lite';
import Table from 'atom-components/table-lite/table';
import TooltipItem from 'atom-components/tooltip-item';
import ActiveMarkerBadge from 'pages/marking/components/active-marker-badge';
import DeallocateMarkerButton from 'pages/marking/components/deallocate-marker-button';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import { useMe } from 'services/assist-api/entities/me/me';
import ReallocateResponseButton from './reallocate-response-button';

function MarkerBadgeWithTooltip({
  allocatedOrganisationUser
}: {
  allocatedOrganisationUser: BaseCustomerUser;
}): ReactElement {
  const meQuery = useMe();
  const currentOrganisationUser = meQuery.data?.customerUser;

  const displayWarning =
    currentOrganisationUser && currentOrganisationUser.id !== allocatedOrganisationUser.id;

  return (
    <TooltipItem tooltip={`@${allocatedOrganisationUser.user.username}`}>
      <ActiveMarkerBadge
        displayWarning={displayWarning ?? false}
        activeMarker={undefined}
        defaultActiveMarkerToOrgUser
        organisationUser={allocatedOrganisationUser}
        isAiMarked={undefined}
      />
    </TooltipItem>
  );
}

type Props = {
  responseId: number;
  allocatedMarkerId: number;
  allocatedOrganisationUser: BaseCustomerUser;
  onDeallocate: () => void;
  isLoading: boolean;
};

export default function TableRow({
  responseId,
  allocatedMarkerId,
  allocatedOrganisationUser,
  onDeallocate,
  isLoading
}: Props): ReactElement {
  return (
    <Table.Row>
      <Table.DataCell>
        <MarkerBadgeWithTooltip allocatedOrganisationUser={allocatedOrganisationUser} />
      </Table.DataCell>
      <Table.DataCell>
        <TableActions>
          <DeallocateMarkerButton
            responseId={responseId}
            allocatedMarkerId={allocatedMarkerId}
            allocatedOrganisationUser={allocatedOrganisationUser}
            onDeallocate={onDeallocate}
          />
          <ReallocateResponseButton
            responseId={responseId}
            allocatedMarkerId={allocatedMarkerId}
            allocatedOrganisationUser={allocatedOrganisationUser}
            onReallocate={onDeallocate}
            isLoading={isLoading}
          />
        </TableActions>
      </Table.DataCell>
    </Table.Row>
  );
}
